const reducerName = 'qiibee';

export const apiTypes = {};

export const syncTypes = {
  SIGN_IN: `${reducerName}/SIGN_IN`,
  SIGN_UP: `${reducerName}/SIGN_UP`,
  LOGOUT: `${reducerName}/LOGOUT`,
  FOLLOW_BRAND: `${reducerName}/FOLLOW_BRAND`,
  REDEEM_POINTS: `${reducerName}/REDEEM_POINTS`,
  AWARDS_POINTS: `${reducerName}/AWARDS_POINTS`,
};
